// packages/compose/src/higher-order/compose.ts
import { basePipe } from "./pipe";
var compose = basePipe(true);
var compose_default = compose;
export {
  compose_default as default
};
//# sourceMappingURL=compose.js.map
